var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6367 9.49609C12.6289 8.0625 13.2773 6.98047 14.5898 6.18359C13.8555 5.13281 12.7461 4.55469 11.2812 4.44141C9.89453 4.33203 8.37891 5.25 7.82422 5.25C7.23828 5.25 5.89453 4.48047 4.83984 4.48047C2.66016 4.51562 0.34375 6.21875 0.34375 9.68359C0.34375 10.707 0.53125 11.7643 0.90625 12.8555C1.40625 14.2891 3.21094 17.8047 5.09375 17.7461C6.07812 17.7227 6.77344 17.0469 8.05469 17.0469C9.29688 17.0469 9.94141 17.7461 11.0391 17.7461C12.9375 17.7188 14.5703 14.5234 15.0469 13.0859C12.5 11.8867 12.6367 9.57031 12.6367 9.49609ZM10.4258 3.08203C11.4922 1.81641 11.3945 0.664062 11.3633 0.25C10.4219 0.304688 9.33203 0.890625 8.71094 1.61328C8.02734 2.38672 7.625 3.34375 7.71094 4.42188C8.73047 4.5 9.66016 3.97656 10.4258 3.08203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.821e0517bc615079d5d0e47f7f8268fa.svg";
export { ForwardRef as ReactComponent };